import {isset} from "../tools/isset.js";

let player = null;



export const video_btn = (selector) => {
    const btns = document.querySelectorAll('.video__btn');
    if (btns.length > 0) {
      youtube_player();
      btns.forEach(btn => {
        btn.addEventListener('click', event => {
          event.preventDefault();
          video_show(btn);
        })
      })

      window.onYouTubePlayerAPIReady = () => {
        player = new YT.Player('ytplayer', {
          height: '360',
          width: '640',
          autoplay: true,
          events: {
            'onReady': youtube_player_ready,
          }
        });
      }
    }
}

export const hero_video_size = () => {
    const video = document.querySelector('.hero--main video');

    if (video) {
        const parent = video.parentElement.getBoundingClientRect();

        video.style.setProperty('min-width', `${parent.width}px`);
        video.style.setProperty('min-height', `${parent.height}px`);
    }
}

export const youtube_player = (selector) => {

    if (!isset(() => YT)) {
        load_youtube_script();
    }
}


const load_youtube_script = () => {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    const script_tag = document.getElementsByTagName('script')[0];
    script_tag.parentNode.insertBefore(tag, script_tag);
}

export const video_show = (btn) => {
    const video_parent = btn.closest('.video__content');
    let last_video_id = '';


    if (video_parent) {
      const video_id = btn.getAttribute('data-video-id');
      player.loadVideoById(video_id);
      btn.classList.add('hide')
    }
}

const youtube_player_ready = (event) => {
  //  event.target.playVideo();
}
